import { useEffect } from 'react';

/**
 * 個人のプロフィールを出すページを検索エンジンに載せない。
 *
 * 招待ページ（swaycross.com/{user_number}）は認証なしでニックネーム・再生履歴などを表示し、
 * user_number が連番なので総当たりで全員ぶん見られる。検索結果に残らないよう noindex を付ける。
 * Googlebot は JavaScript を実行してから meta を読むので、SPA でもこの方法で効く。
 */
export const useNoIndex = (): void => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow, noarchive';
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);
};
